import { render, staticRenderFns } from "./WorkView.vue?vue&type=template&id=b97cb56e&scoped=true"
import script from "./WorkView.vue?vue&type=script&lang=js"
export * from "./WorkView.vue?vue&type=script&lang=js"
import style0 from "./WorkView.vue?vue&type=style&index=0&id=b97cb56e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97cb56e",
  null
  
)

export default component.exports